import { contentClient } from '@wajeez-web/core/api-base';
import {
  thunkErrorHandlerWithoutSdk,
  thunkResponseChecker,
} from '@wajeez-web/core/utils';
import { ApiMethod } from '@wajeez-web/stores/base';

import { BadgeOutput, CreateBadgeInput } from './types';

export const getBadgesLookups: ApiMethod<
  string | undefined,
  BadgeOutput[],
  void
> = async (searchString, { dispatch, rejectWithValue }) => {
  return thunkErrorHandlerWithoutSdk(
    async () => {
      return thunkResponseChecker(async () => {
        return contentClient.get('api/content/v1/admin/Badges/lookups', {
          params: {
            SearchString: searchString,
          },
        });
      }, rejectWithValue);
    },
    dispatch,
    rejectWithValue
  );
};

export const createBadge: ApiMethod<CreateBadgeInput, number, void> = async (
  body,
  { dispatch, rejectWithValue }
) => {
  return thunkErrorHandlerWithoutSdk(
    async () => {
      return thunkResponseChecker(async () => {
        return contentClient.post('api/content/v1/admin/Badges', body);
      }, rejectWithValue);
    },
    dispatch,
    rejectWithValue
  );
};
